import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductFilters } from '../../types';
import './ProductFilter.css';

interface ProductFilterProps {
  currentFilters: ProductFilters;
  onFilterChange: (filters: ProductFilters) => void;
}

const ProductFilter: React.FC<ProductFilterProps> = ({ currentFilters, onFilterChange }) => {
  const { t } = useTranslation();
  const [priceMin, setPriceMin] = useState(currentFilters.price_min || '');
  const [priceMax, setPriceMax] = useState(currentFilters.price_max || '');
  const [sortBy, setSortBy] = useState(currentFilters.ordering || '');



  const handleApplyFilters = () => {
    onFilterChange({
      price_min: priceMin ? Number(priceMin) : undefined,
      price_max: priceMax ? Number(priceMax) : undefined,
      ordering: sortBy || undefined,
    });
  };

  const handleClearFilters = () => {
    setPriceMin('');
    setPriceMax('');
    setSortBy('');
    onFilterChange({});
  };

  return (
    <div className="product-filter">
      <h3>{t('filters.title')}</h3>



      {/* Price Range Filter */}
      <div className="filter-section">
        <h4>{t('filters.priceRange')}</h4>
        <div className="price-inputs">
          <input
            type="number"
            placeholder={t('filters.min')}
            value={priceMin}
            onChange={(e) => setPriceMin(e.target.value)}
            className="price-input"
          />
          <span>-</span>
          <input
            type="number"
            placeholder={t('filters.max')}
            value={priceMax}
            onChange={(e) => setPriceMax(e.target.value)}
            className="price-input"
          />
        </div>
      </div>

      {/* Sort By */}
      <div className="filter-section">
        <h4>{t('filters.sortBy')}</h4>
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          className="filter-select"
        >
          <option value="">{t('filters.default')}</option>
          <option value="-created_at">{t('filters.newest')}</option>
          <option value="price">{t('filters.priceLowToHigh')}</option>
          <option value="-price">{t('filters.priceHighToLow')}</option>
          <option value="-sales_count">{t('filters.popular')}</option>
        </select>
      </div>

      {/* Action Buttons */}
      <div className="filter-actions">
        <button onClick={handleApplyFilters} className="apply-btn">
          {t('buttons.apply')}
        </button>
        <button onClick={handleClearFilters} className="clear-btn">
          {t('buttons.clear')}
        </button>
      </div>
    </div>
  );
};

export default ProductFilter;
